import React from "react";
import { Alert, Input } from "antd";

const { TextArea } = Input;

export default function AdvancedCampaignContentFields({
  emailSubject,
  emailBody,
  persistedEmailBody,
  hasStoredVariations,
  onEmailSubjectChange,
  onEmailBodyChange,
  terminalCampaign = false
}) {
  const bodyChanged =
    String(emailBody || "").trim() !== String(persistedEmailBody || "").trim();

  return (
    <div className="advanced-content-fields">
      <div className="form-group">
        <label htmlFor="advanced-email-subject">
          <span className="field-label">
            <span aria-hidden="true" style={{ color: "red" }}>*</span> Email Subject
          </span>
        </label>
        <Input
          id="advanced-email-subject"
          aria-label="Email Subject"
          required
          maxLength={200}
          value={emailSubject}
          onChange={(event) => onEmailSubjectChange(event.target.value)}
          placeholder="Enter email subject"
        />
      </div>
      <div className="form-group">
        <label htmlFor="advanced-email-body">
          <span className="field-label">
            <span aria-hidden="true" style={{ color: "red" }}>*</span> Email Content
          </span>
        </label>
        <TextArea
          id="advanced-email-body"
          aria-label="Email Content"
          required
          rows={6}
          maxLength={10000}
          value={emailBody}
          onChange={(event) => onEmailBodyChange(event.target.value)}
          placeholder="Enter email content"
        />
      </div>
      <Alert
        className="advanced-content-notice"
        type="info"
        showIcon
        message="Changes apply to future unsent emails. An email already being sent may use the previous version."
      />
      {terminalCampaign && (
        <p className="advanced-content-terminal-note">
          Saving changes updates the stored campaign details only. It will not restart this campaign or send email.
        </p>
      )}
      {hasStoredVariations && bodyChanged && (
        <Alert
          className="advanced-content-variation-warning"
          type="warning"
          showIcon
          message="Saving changed email content replaces this campaign’s existing generated variations for future emails."
        />
      )}
    </div>
  );
}
